import React from 'react'
import { Button } from '../../components/ui/Button';
import { Input, TokenInput } from '../../components/ui/Input';
import Layout from '../../components/layout/Layout';
import { useRegister } from './hook/useRegister';
import { Step1Component, Step2Component, Step3Component, Step4Component } from '../../components/modal/personalDataModal/PersonalDataSteeps';
import { CgSpinner } from 'react-icons/cg';
import Header from '../../components/layout/Header';
import { ReSendToken } from '../../service/controller/LoanController';

function Register() {
    const {
        StepProgress,
        handleSubmit,
        currentStep,
        handleChange,
        form,
        errors,
        inputsPersonalData,
        checkSMSToken,
        onSubmitPassword,
        navigate,
        setCurrentStep,
        onSetTypePerson,
        isRequiredToken
    } = useRegister();

    return (
        <React.Fragment>
            <Header />
            {!isRequiredToken && <div className="min-h-screen flex">
                {/* Lado Esquerdo */}
                <div className="w-1/2 hidden sm:flex bg-gray-100 flex items-center justify-center relative">
                    <div className="fçex text-3xl font-bold text-purple-900 items-center justify-center gap-2">
                        <img src="/assets/logo-lojao-bmg.png" alt="" />
                    </div>
                </div>

                {/* Lado Direito */}
                <div className="w-full sm:w-1/2 flex flex-col justify-center px-2 sm:px-20">
                    <img className='block sm:hidden' src="/assets/logo-lojao-bmg.png" alt="" />
                    <StepProgress />
                    <form className="space-y-4">
                        {currentStep === 1 && <Step1Component onSetTypePerson={onSetTypePerson} />}
                        {currentStep === 2 && <Step2Component form={form} handleChange={handleChange} errors={errors} inputsPersonalData={inputsPersonalData} />}
                        {currentStep === 3 && <Step3Component onSubmitPassword={onSubmitPassword} />}
                    </form>

                    {currentStep === 2 && <div div className="flex items-center justify-between mt-6">
                        <Button onClick={() =>
                            currentStep === 1 ? navigate(-1) : setCurrentStep(currentStep - 1)
                        } variant='outline'>
                            Voltar
                        </Button>
                        <Button onClick={handleSubmit}>
                            Continuar
                        </Button>
                    </div>}
                </div>
            </div>}
            {isRequiredToken && <div className="min-h-screen flex">
                <div className="w-1/2 hidden sm:flex bg-gray-100 flex items-center justify-center relative">
                    <div className="fçex text-3xl font-bold text-purple-900 items-center justify-center gap-2">
                        <img src="/assets/logo-lojao-bmg.png" alt="" />
                    </div>
                </div>
                <div className="w-full sm:w-1/2 flex flex-col justify-center px-2 sm:px-20">
                    <TokenInput
                        labelChildren='validar mais tarde'
                        hideBtnForwarding
                        label={'Informe o token enviado'}
                        onComplete={checkSMSToken}
                        onResend={()=> ReSendToken()}
                    >
                        <div className="flex gap-5 items-center justify-between">
                            <Button variant='outline' className='mt-5'>Validar Depois</Button>
                        </div>
                    </TokenInput>
                </div>
            </div>}
        </React.Fragment >
    );
}

export default Register